import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Link } from "react-router-dom"
import './ForgetPassword.css'
import { getPasswordResetToken } from "../../services/operations/authAPI"

function ForgotPassword() {
  const [email, setEmail] = useState("")
  const [emailSent, setEmailSent] = useState(false)
  const dispatch = useDispatch()
  const { loading } = useSelector((state) => state.auth)

  const handleOnSubmit = (e) => {
    e.preventDefault()
    dispatch(getPasswordResetToken(email, setEmailSent))
  }

    return (
        <div className="forgot-password-container">
            <div className="form-container">
                <h2 className="logo-container">
                    {!emailSent ? "Reset your password" : "Check email"}</h2>
                <p className="my-4 text-[1.125rem] leading-[1.625rem] text-richblack-700">
                {!emailSent
              ? "Have no fear. We'll email you instructions to reset your password."
              : `We have sent the reset email to ${email}`}
          </p>
                <form className="form" onSubmit={handleOnSubmit}>
                    <div className="form-group">
                        <label htmlFor="email">Email<sup className="text-pink-200">*</sup></label>
                        <input
                  required
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter email address"
                />
                    </div>
                    <button className="form-submit-btn" type="submit">{!emailSent ? "Sumbit" : "Resend Email"}</button>
                </form>
                <p className="signup-link">
                    Don't have an account? <Link to="/signup">
                              <button className="signup-button">Sign Up</button>
                            </Link>
                </p>
            </div>
        </div>
    );
}

export default ForgotPassword;
